var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 325,
    viewBox: "0 0 343 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.498 79.4676L266.572 79.5309L266.641 79.5998C272.889 85.8482 272.889 95.9788 266.641 102.227C260.426 108.441 250.372 108.475 244.116 102.329L188.413 57.7917V218C188.413 226.837 181.25 234 172.413 234C163.577 234 156.413 226.837 156.413 218V57.7917L100.711 102.329C94.4548 108.475 84.4006 108.441 78.1863 102.227C71.9379 95.9788 71.9379 85.8482 78.1863 79.5998L78.2551 79.5309L78.3291 79.4676L161.172 8.61476C167.402 2.46172 177.425 2.46172 183.655 8.61476L266.498 79.4676Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 228.312C33.5 220.028 26.7843 213.312 18.5 213.312C10.2157 213.312 3.5 220.028 3.5 228.312V286.25C3.5 305.58 19.17 321.25 38.5 321.25H320.5C331.546 321.25 340.5 312.296 340.5 301.25V228.312C340.5 220.028 333.784 213.312 325.5 213.312C317.216 213.312 310.5 220.028 310.5 228.312V291.25H38.5C35.7386 291.25 33.5 289.012 33.5 286.25V228.312Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUl);
export default __webpack_public_path__ + "static/media/icon-ul.96bc9e74c4080ba7d9ac0fb09c413d3a.svg";
export { ForwardRef as ReactComponent };